<template>
  <v-dialog v-model="dialogStatus" max-width="600" transition="dialog-bottom-transition">
    <v-card>
      <div class="d-flex align-end mb-3">
        <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
          <v-icon color="white"> mdi-bookmark </v-icon>
        </v-card>
        <span class="h4 ml-1 mb-n1">编辑器信息</span>
      </div>
      <v-form v-model="valid" ref="form">
        <v-container>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field v-model="form.name" label="场景名称" required :rules="rules['name']"> </v-text-field>
              <v-textarea class="mt-2" v-model="form.description" label="场景描述" auto-grow clearable></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.stop="confirm">提交</v-btn>
        <v-btn color="gray" @click.stop="$store.dispatch('editor/reverseShowSceneEdit', false)">取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  computed: {
    dialogStatus: {
      get() {
        const status = this.$store.state.editor.showSceneEdit
        if (status === 'add') {
          this.$nextTick(() => {
            this.$refs.form?.resetValidation()
            this.$refs.form?.reset()
          })
          this.form = {}
        }
        if (status === 'edit') {
          this.form = Object.assign({}, this.$store.state.editor.checkSceneInfo)
        }
        return status === 'edit' || status === 'add'
      },
      set(val) {
        if (!val) {
          this.$store.dispatch('editor/reverseShowSceneEdit', 'close')
        }
      }
    }
  },
  data: () => ({
    valid: false,
    form: {
      name: '',
      taskMode: '',
      task_editor_id: '',
      description: '',
      isPublic: false
    },
    rules: {
      name: [(v) => !!v || '请填写场景名称']
    },
    nodeText: ''
  }),
  methods: {
    confirm() {
      this.$refs.form.validate()
      if (this.valid) {
        this.$store.dispatch('editor/initEditor', this.form)
      }
    }
  }
}
</script>
